import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';
import logo from '../assets/logo.png';

export default function Press() {
  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4.5rem 5% 3rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#F5A623', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>Press</div>
        <h1 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em', marginBottom: '1rem' }}>
          Media & Press Resources
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-2)', lineHeight: 1.75, maxWidth: 600, margin: '0 auto' }}>
          For press inquiries, interview requests, or brand assets, reach out to our media contact below.
        </p>
      </section>

      <section style={{ padding: '0 5% 4rem' }}>
        <div style={{ maxWidth: 700, margin: '0 auto', display: 'grid', gap: '1.25rem' }}>
          <div style={{ padding: '1.75rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-1)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.75rem' }}>Brand Assets</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ padding: '1rem', background: 'var(--bg)', borderRadius: 12, border: '1px solid var(--border)' }}>
                <img src={logo} alt="PCredit logo" style={{ height: 40, width: 'auto' }} />
              </div>
              <p style={{ fontSize: '0.85rem', color: 'var(--text-2)', lineHeight: 1.6, flex: 1, minWidth: 200 }}>
                The PCredit name and logo are trademarks of Premiumreal Technologies Limited. Please contact us before using our brand assets in any publication.
              </p>
            </div>
          </div>

          <div style={{ padding: '1.75rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-1)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.75rem' }}>Media Contact</div>
            <p style={{ fontSize: '0.85rem', color: 'var(--text-2)', lineHeight: 1.6, marginBottom: '1rem' }}>
              For interviews, quotes, or press coverage, get in touch with our team.
            </p>
            <a href="mailto:press@mypcredit.com" className="btn btn-primary">Email press@mypcredit.com</a>
          </div>
        </div>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
